const FixedSizeIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Horizontal arrows */}
      <path
        d="M2 8L4 6.5M2 8L4 9.5M2 8H6"
        stroke="currentColor"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 8L12 6.5M14 8L12 9.5M14 8H10"
        stroke="currentColor"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Vertical arrows */}
      <path
        d="M8 2L6.5 4M8 2L9.5 4M8 2V6"
        stroke="currentColor"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 14L6.5 12M8 14L9.5 12M8 14V10"
        stroke="currentColor"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Center box */}
      <rect x="6.5" y="6.5" width="3" height="3" stroke="currentColor" strokeWidth="0.8" fill="none" />
    </svg>
  );
};

export default FixedSizeIcon;
